import { Component, Input, OnInit } from '@angular/core';
import { MealPlanItem, Recipe } from 'app/models/recipe.model';
import { BaseComponent } from 'app/common/components/base.component';
import { iconTrash } from 'app/common/utils/icons.utils';

@Component({
	selector: 'meal-item-component',
	templateUrl: './meal-item.component.html',
	styleUrls: ['./meal-item.component.scss']
})
export class MealPlanItemComponent extends BaseComponent implements OnInit{
	@Input("mealItem") mealItem: MealPlanItem[];
	@Input("dayOfWeek") dayOfWeek: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
	@Input("myRecipes") myRecipes: Recipe[] = [];
	@Input("switchRecipes") switchRecipes: Recipe[] = [];
	iconRemove = iconTrash;
	ngOnInit(): void {
	}

	selectRecipe = (recipe: Recipe, index: number, when: 'lunch' | 'dinner') => {
		if (when == 'lunch') {
			this.mealItem[index].recipeIdLunch = (recipe)?recipe.id:null;
			this.mealItem[index].recipeNameLunch = (recipe)?recipe.recipeName:null;
			this.mealItem[index].recipeClassLunch = (recipe)?recipe.envScoreClass:null;
		}
		else {
			this.mealItem[index].recipeIdDinner = (recipe)?recipe.id:null;
			this.mealItem[index].recipeNameDinner = (recipe)?recipe.recipeName:null;
			this.mealItem[index].recipeClassDinner = (recipe)?recipe.envScoreClass:null;
		}
	}
}